import { createStore } from 'satcheljs';
var initialState = {
    notificationViewStates: [],
};
export default createStore('headerToastNotificationViewState', initialState)();
//# sourceMappingURL=store.js.map